import React, { useContext, useState, useRef } from 'react';
import { withStyles } from '@material-ui/core';
import DataContext from '../../data/DataContext';
import Search from '../../../asset/img/Icon_menu_search_white.svg'; //"../../../asset/img/main_menu_search.svg";
import Recommend from '../../../asset/img/Icon_menu_recommend_products_white.svg'; //"../../../asset/img/main_menu_recommend.svg";
import Rental from '../../../asset/img/Icon_menu_recommend_rental_white.svg'; //"../../../asset/img/main_menu_rental.svg";
import Consulting from '../../../asset/img/Icon_menu_purchasing_expert_white.svg'; //"../../../asset/img/main_menu_consulting.svg";
import Repair from '../../../asset/img/Icon_menu_repair_white.svg'; //"../../../asset/img/main_menu_repair.svg";
import Reservation from '../../../asset/img/Icon_menu_reservation_white.svg'; //"../../../asset/img/main_menu_reservation.svg";
import Center from '../../../asset/img/Icon_menu_location_white.svg'; //"../../../asset/img/main_menu_center.svg";
import Wash from '../../../asset/img/Icon_menu_cleaning_products_white.svg'; //"../../../asset/img/main_menu_wash.svg";
import Expendables from '../../../asset/img/Icon_menu_consumables_white.svg'; //"../../../asset/img/main_menu_expendables.svg";
import BG from '../../../asset/img/start_menu_bg.jpg';
import Install from '../../../asset/img/main_menu_install.svg';
import Event from '../../../asset/img/main_menu_event2.svg';
import Carousel from '../../carousel/Carousel';
import { ToggleButton, ToggleButtonGroup } from '@material-ui/lab';
import { colors } from '@material-ui/core';
const styles = (theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    background: '#f0ece4',
    zIndex: 10,
  },
  btnGroup: {
    height: '1.75rem',
    alignItems: 'center',
    margin: '0rem 1rem',
    border: 'none',
    background: 'none',
  },
  btn: {
    border: '0rem',
    fontSize: '0.875rem',
    fontWeight: 'normal',
    fontStretch: 'normal',
    fontStyle: 'normal',
    lineHeight: '1.14',
    letterSpacing: 'normal',
    textAlign: 'center',
    color: '#666  ',
    justifyContent: 'center',
    alignItems: 'center',
    display: 'flex',
    padding: '0 0 0.3125rem 0',
    margin: '0 0.75rem 0 0.25rem',
    '&:hover': {
      backgroundColor: 'transparent',
    },
    '&:focus': {
      outline: 'auto',
    },
  },
  btnSelected: {
    background: 'none !important',
    border: '0rem',
    fontSize: '0.9375rem',
    fontWeight: 'bold',
    fontStretch: 'normal',
    fontStyle: 'normal',
    lineHeight: '1.07',
    letterSpacing: 'normal',
    textAlign: 'left',
    color: '#000 !important',
    justifyContent: 'center',
    alignItems: 'center',
    display: 'flex',
    borderBottom: '0.125rem solid #ea1917',
    borderRadius: 0,
  },
  menuContainer: {
    height: '18.25rem',
    padding: '1rem 0rem',
    width: '100%',
    minWidth: '100%',
    cursor: 'pointer',
  },
  menuUl: {
    margin: '0rem',
    padding: '0rem',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    backgroundImage: `url(${BG})`,
    backgroundRepeat: 'no-repeat',
    borderRadius: '0.625rem',
    backgroundSize: 'cover',
  },
  menuItem: {
    // "&:first-child":{
    //   borderRadius:"0.625rem 0.625rem 0rem 0rem"
    // },
    // "&:last-child":{
    //   borderRadius:"0rem 0rem 0.625rem 0.625rem"
    // },
    borderBottom: '1px solid rgb(255 255 255 / 50%)',
    '&:last-child': {
      border: 'none',
    },
    fontFamily: 'inherit',
    fontSize: theme.font.size14,
    fontWeight: '500',
    fontStretch: 'normal',
    fontStyle: 'normal',
    lineHeight: '1.14',
    letterSpacing: 'normal',
    textAlign: 'left',
    color: '#fff',
    display: 'flex',
    height: '3.25rem',
    padding: '0rem 1.25rem',
    display: 'flex',
    alignItems: 'center',
  },
  menuButton: {
    border: 'none',
    background: 'none',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    width: '100%',
  },
  menuLabel: {
    display: 'flex',
    alignItems: 'center',
    color: '#fff',
  },
  menuIcon: {
    width: '1.5rem',
    height: '1.5rem',
  },
  carouselRoot: {},
});

const menu = {
  자주찾는질문: [
    {
      type: 'speech',
      speech: '스스로해결/출장예약',
      label: '스스로해결/출장예약',
      icon: Repair,
      intent: 'THQ_DIAGNOSIS',
    },
    {
      type: 'speech',
      speech: '제품 검색/구매',
      label: '제품 검색/구매',
      icon: Search,
      intent: 'THQ_PRODUCT_SEARCH',
    },
    {
      type: 'speech',
      speech: '소모품 검색/구매',
      label: '소모품 검색/구매',
      icon: Expendables,
      intent: 'THQ_EXPENDABLES_PURCHASE',
    },
    {
      type: 'speech',
      speech: '서비스 예약 확인/변경',
      label: '서비스 예약 확인/변경',
      icon: Reservation,
      intent: 'THQ_BOOK_CHECK',
    },
    {
      type: 'speech',
      speech: '이전설치',
      label: '이전설치',
      icon: Install,
      intent: 'THQ_RELOCATE_BOOK',
    },
  ],
  제품구매: [
    {
      type: 'speech',
      speech: '제품 검색/구매',
      label: '제품 검색/구매',
      icon: Search,
      intent: 'THQ_PRODUCT_SEARCH',
    },
    {
      type: 'speech',
      speech: '기획전/이벤트',
      label: '기획전/이벤트',
      icon: Event,
      intent: 'THQ_EVENT_SEARCH',
    },
    // {
    //   type: 'speech',
    //   speech: '제품 추천',
    //   label: '제품 추천',
    //   icon: Recommend,
    //   intent: 'THQ_PRODUCT_RECOMMEND',
    // }, //, parameters: {search_type: "lifestyle"}},
    {
      type: 'speech',
      speech: '구독 추천',
      label: '구독 추천',
      icon: Rental,
      intent: 'THQ_PRODUCT_RENTAL',
    },
    {
      type: 'speech',
      speech: '소모품 검색/구매',
      label: '소모품 검색/구매',
      icon: Expendables,
      intent: 'THQ_EXPENDABLES_PURCHASE',
    },
    {
      type: 'speech',
      speech: '구매전문가 상담',
      label: '구매전문가 상담',
      icon: Consulting,
      intent: 'THQ_PURCHASE_EXPERT_CHAT',
    },
  ],
  고객지원: [
    {
      type: 'speech',
      speech: '스스로해결/출장예약',
      label: '스스로해결/출장예약',
      icon: Repair,
      intent: 'THQ_DIAGNOSIS',
    },
    {
      type: 'speech',
      speech: '서비스 예약 확인/변경',
      label: '서비스 예약 확인/변경',
      icon: Reservation,
      intent: 'THQ_BOOK_CHECK',
    },
    {
      type: 'speech',
      speech: '서비스센터 찾기',
      label: '서비스센터 찾기',
      icon: Center,
      intent: 'THQ_SERVICECENTER_LOCATION',
    },
    {
      type: 'speech',
      speech: '가전 세척 예약',
      label: '가전 세척 예약',
      icon: Wash,
      intent: 'THQ_CLEAN_SERVICE',
    },
    {
      type: 'speech',
      speech: '이전 설치',
      label: '이전 설치',
      icon: Install,
      intent: 'THQ_RELOCATE_BOOK',
    },
  ],
};

const Menu = React.forwardRef((props, ref) => {
  const { classes, activeSlide } = props;
  const data = useContext(DataContext);

  const handleClick = (item) => {
    if (!ref.clickAllowed()) {
      console.log(`[STARTMENU] handleClick - Carousel swipe - click is not allowed`);
      return;
    }

    if (data.conversationEnd) {
      console.log(`[STARTMENU] handleClick - conversation end`);
      return;
    }

    if (item?.type === 'action_backend') {
      data.request(data, item.speech, 'button', item?.parameters, {
        mode: 'bypass',
        intent: item.intent,
      });
    } else {
      data.request(data, item.speech, 'button');
    }
  };

  return Object.keys(menu).map((m, index) => (
    <div className={classes.menuContainer} key={`menu_${index}`}>
      <ul className={classes.menuUl}>
        {menu[m].map((item, idx) => (
          <li
            onClick={() => {
              handleClick(item);
            }}
            className={classes.menuItem}
            key={`menu_${index}_${idx}`}
            style={{ '--idx': 1 - idx * 0.1 }}
          >
            <button
              className={classes.menuButton}
              aria-hidden={activeSlide !== index}
              tabIndex={activeSlide !== index ? '-1' : ''}
            >
              <div className={classes.menuLabel}>{item.label}</div>
              <img src={item.icon} className={classes.menuIcon} alt="" />
            </button>
          </li>
        ))}
      </ul>
    </div>
  ));
});
const MenuCarousel = withStyles(styles)((props) => {
  const { classes, selectedIndex, updateSelectedIndex } = props;
  return (
    <Carousel
      className={classes.carouselRoot}
      component={withStyles(styles)(Menu)}
      data={menu}
      dragFree={false}
      indicator={false}
      selectedIndex={selectedIndex}
      updateSelectedIndex={updateSelectedIndex}
      startIndex={0}
    />
  );
});
const NavButtons = withStyles(styles)((props) => {
  const { classes, selected, changeIndex } = props;
  const handleChange = (e, newButtonVal) => {
    if (newButtonVal !== null) changeIndex(newButtonVal);
  };

  // const buttonRef = useRef();
  // const onClickToggleButton = (e) => {
  //   console.log('buttonRef.current', buttonRef.current);
  //   console.log('buttonRef.current', buttonRef.current.getAttribute('aria-pressed'));
  // };

  return (
    <ToggleButtonGroup
      exclusive
      classes={{ root: classes.btnGroup }}
      value={selected}
      onChange={handleChange}
      // onClick={onClickToggleButton}
    >
      {Object.keys(menu).map((key, index) => {
        return (
          <ToggleButton
            key={key}
            classes={{ root: classes.btn, selected: classes.btnSelected }}
            disableFocusRipple={true}
            disableRipple={true}
            value={index}
            aria-selected={selected === index}
            role="tab"
            title={selected === index ? '선택됨' : null}
            // ref={buttonRef}
          >
            {key}
          </ToggleButton>
        );
      })}
    </ToggleButtonGroup>
  );
});
function STARTMENU(props) {
  const { classes, data } = props;
  const context = useContext(DataContext);
  const [selectedIndex, setSelectedIndex] = useState(0);
  const changeIndex = (index) => {
    setSelectedIndex(index);
  };

  return (
    <div className={classes.root}>
      <NavButtons selected={selectedIndex} changeIndex={changeIndex}></NavButtons>
      <MenuCarousel selectedIndex={selectedIndex} updateSelectedIndex={changeIndex} />
    </div>
  );
}
export default withStyles(styles)(STARTMENU);
